<template>

    <ui-data-grid-section :subtitle="subtitle" :title="title">
      <ui-data-grid-item :value="dailyRate | toCurrency" label="Daily Rate"></ui-data-grid-item>
      <ui-data-grid-item :value="`${hoursInDay} hrs`" label="Hours In Day"></ui-data-grid-item>
      <ui-data-grid-item :value="hourly_rate | toCurrency" label="Hourly Rate"></ui-data-grid-item>
      <ui-data-grid-item :label="`Cost Per ${uom}`">
        {{ cost_per_uom | toCurrency }} Per {{ uom }}
      </ui-data-grid-item>
    </ui-data-grid-section>

</template>

<script>
export default {
  props: {
    title: {type: String, required: true, default: "Buy Rates"},
    subtitle: {type: String, required: false, default: ""},
    uom: String,
    unitsPerHour: Number,
    hoursInDay: Number,
    dailyRate: Number
  },
  computed: {
    hourly_rate() {
      return this.dailyRate / this.hoursInDay;
    },
    cost_per_uom() {
      return this.hourly_rate / this.unitsPerHour;
    }
  },
  methods: {},
}
</script>
